import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalize',
})
export class CapitalizePipe implements PipeTransform {
  transform(value: string, everyWord?: boolean): string {
    if (value) {
      if (everyWord) {
        return value.replace(/\b\w/g, (symbol) => symbol.toLocaleUpperCase());
      } else {
        return value.charAt(0).toLocaleUpperCase() + value.slice(1);
      }
    }

    return value;
  }
}
